import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ExperimentHoldoutRowDataProps } from 'modules/experiments/types';
import { localizeNumber } from 'utils/l10n';
import {
  HoldoutContent,
  HoldoutDetails,
  HoldoutHeader,
  HoldoutIcon,
  HoldoutWrapper,
  HoldoutInnerWrapper,
} from './Styled';

export const HoldoutDetailsCell = ({ row }: ExperimentHoldoutRowDataProps) => {
  const { t } = useExperimentsTranslations();
  const { userCount, holdoutGroupPercent } = row;

  return (
    <HoldoutWrapper data-test="experiment-holdout-detail-cell">
      <HoldoutInnerWrapper>
        <HoldoutIcon>H/O</HoldoutIcon>
        <HoldoutContent>
          <HoldoutHeader>{t('variantTable.cell.holdoutGroup')}</HoldoutHeader>
          <HoldoutDetails>
            {t('variantTable.cell.holdoutGroupDetails', {
              userCount: localizeNumber(userCount || 0),
              holdoutGroupPercent,
            })}
          </HoldoutDetails>
        </HoldoutContent>
      </HoldoutInnerWrapper>
    </HoldoutWrapper>
  );
};
